module.exports = __webpack_public_path__ + "img/202312_08.34f8adb5.jpg";